// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"301":"b0ffe93e9bfdd97128ed","320":"7e4203d0b5bddb22d596"}[chunkId] + ".js";
};